export type {ButtonProps} from './Button.interface';
export {Button} from './Button';